import React, { Fragment } from "react";
import styles from "../../styles/pages/myaccount.module.scss";
import MUITextField from "../common/ui-components/input/MUITextField";
import { useRouter } from "next/router";
import { VerifyEmailOTP, SendEmailOTP } from "../../api/myaccount";
import { getApplication, getNextPath, getUrlParams } from "../../utils/index";
import Cookies from "js-cookie";
import { setCustomerCookie } from "../../api/cookies";
import {
  pushToSegmentIdentify,
  resetUserSegment,
} from "../../utils/tracking/index";
import { loginSuccess } from "../../tracking/segment/loginPage";
import store from "../../redux";
import { downloadCertificatePopup } from "../../redux/actions/orderActions";
import Button from "../common/ui-components/input/Button";
import { getCachedRecaptchaToken, isRecaptchaReady } from "../../utils/recaptcha";
import ReCAPTCHA from "react-google-recaptcha";
import Config from "../../config";

const EmailVerification = (props: any) => {
  const [email, setEmail] = React.useState<string>(props.email);
  const router = useRouter();
  const [timer, setTimer] = React.useState<any>(null);
  const [resenttimer] = React.useState<any>(null);
  const [count, setCount] = React.useState<number>(0);
  const [emailOtp, setEmailOtp] = React.useState<string>("");
  const [emailOtpError, setEmailOtpError] = React.useState<string>("");
  const [btnLoader, setBtnLoader] = React.useState<boolean>(false);
  const [otpSent, setOtpSent] = React.useState<boolean>(false);
  const [isCaptchaRequired, setIsCaptchaRequired] = React.useState<boolean>(false);
  const [isCaptchaVerified, setIsCaptchaVerified] = React.useState<boolean>(false);
  const [captchaV2Token, setCaptchaV2Token] = React.useState<string>("");
  const [sessionCaptchaToken, setSessionCaptchaToken] = React.useState<string>("");
  const recaptchaV2Key = Config.RECAPTCHA_V2_SITE_KEY;
  const getCaptchaToken = async (): Promise<string> => {
    return getCachedRecaptchaToken("otp");
  };

  const sendEmailOTP = async (isResend = false) => {
    if (email || props.email) {
      if (!isResend && isCaptchaRequired && !isCaptchaVerified) {
        setEmailOtpError("Please complete the CAPTCHA to continue.");
        return;
      }
      if (!isResend && !isRecaptchaReady() && !captchaV2Token) {
        setEmailOtpError("CAPTCHA not ready. Please refresh the page again.");
        return;
      }
      if (isResend && !sessionCaptchaToken) {
        setEmailOtpError("Please try again.");
        return;
      }
      const captchaToken = isResend ? sessionCaptchaToken : (captchaV2Token || await getCaptchaToken());
      const captchaTokenType = isResend ? "session_verified" : (captchaV2Token ? "v2" : "v3");
      if (!captchaToken) {
        setEmailOtpError("CAPTCHA not ready. Please refresh the page again.");
        return;
      }
      SendEmailOTP({
        application: getApplication(),
        data: {
          type: "customer_merging",
          email: email || props.email,
          template: "email-otp-v1",
          first_name: props.first_name ? props.first_name : ' ',
          last_name: props.last_name ? props.last_name : ' ',
          captcha_token: captchaToken,
          captcha_token_type: captchaTokenType,
        },
      }).then((res: any) => {
        const nextSessionToken =
          res?.data?.session_token ||
          res?.data?.captcha_token ||
          (isResend ? sessionCaptchaToken : captchaToken);
        if (nextSessionToken) {
          setSessionCaptchaToken(nextSessionToken);
        }
        setOtpSent(true);
        setIsCaptchaRequired(false);
        setIsCaptchaVerified(false);
        setCaptchaV2Token("");
        setCountdownTimer(30);
      }).catch((err: any) => {
        if (!(err instanceof Response)) {
          return;
        }
        err.json().then((res:any) => {
          const errorCodes = res?.error_code;
          const isAuthFailed = errorCodes.includes("recaptcha_verification_failed");
          const isAdditionalAuthRequired = errorCodes.includes("additional_authentication_required");
          if (isAuthFailed) {
            setEmailOtpError("Please refresh the page. If not, the page will refresh automatically in 10 seconds.");
            setTimeout(() => {
              window.location.reload();
            }, 10000);
            return;
          }
          if (isAdditionalAuthRequired) {
            setIsCaptchaRequired(true);
            setOtpSent(false);
            setIsCaptchaVerified(false);
            setCaptchaV2Token("");
            setEmailOtpError("Please complete the CAPTCHA to continue.");
            return;
          }
        })
      });
    }
  };

  const verifyEmailOTP = () => {
    if (emailOtp) {
      setBtnLoader(true);
      VerifyEmailOTP({
        application: getApplication(),
        data: {
          type: "customer_merging",
          email: email,
          template: "email-otp-v1",
          otp: emailOtp,
          first_name: props.first_name ? props.first_name: ' ',
          last_name: props.last_name ? props.last_name : ' ',
          receive_whatsapp_updates: true,
          customer_token: props.customer_token,
          cart_id: props.cart?.token_id,
        },
      })
        .then(async (res: any) => {
          if (res.data?.status) {
            if ("is_authenticate" in res.data) {
              Cookies.set("is_authenticate", true);
              setCustomerCookie(res?.data);
              props.updateCustomerDetails({
                customer_token: res?.data?.token,
                ...res.data,
              });
              resetUserSegment(res?.data);
              pushToSegmentIdentify(res?.data);
              loginSuccess({ method: "phone login", phone: props.phone });
            }
            if (router.query.next) {
              let path = getUrlParams(getNextPath(router.asPath),router);
              if(router.query.download_certificate){
                store.dispatch(downloadCertificatePopup({ download_certificate_popup: true, download_osid: router.query.osid }))
              }
              window.location.href = window.location.origin + path;
              return;
            } else if (router.query.kycstatus) {
              if(router.query.kycstatus==="true")
              {
                await router.push('/myaccount/#plans')
              }
              else if(router.query.kycstatus==="false")
              {
                await router.push('/myaccount/#profile')
              }
              else
              {
                await router.push(`/`);
              }
            } else {
              await router.push("/");
            }
          } else {
            setEmailOtpError("Invalid OTP");
            setBtnLoader(false);
          }
        })
        .catch((err: any) => {
          console.log("error =>", err);
          setBtnLoader(false);
        })
    }
  };

  const setCountdownTimer = (countFrom) => {
    let counter = countFrom;
    if (timer) {
      clearInterval(timer);
      setTimer(null);
    }
    if (resenttimer) {
      clearTimeout(resenttimer);
    }
    setCount(counter);

    let countDownTimer = setInterval(function () {
      counter = counter - 1;
      setCount(counter);
      if (!(counter > 0)) {
        clearInterval(countDownTimer);
        setTimer(null);
      }
    }, 1000);
    setTimer(countDownTimer);
  };

  React.useEffect(() => {
    if(props.email){
      setEmail(props.email)
      sendEmailOTP()
    }
  }, [props.email]);

  let ctaEmailText: any,
    ctaEmailClick: any = null;

  if (otpSent) {
    if (count != 0) {
      ctaEmailText = `OTP Sent (${count})`;
    } else {
      ctaEmailText = "Resend OTP";
      ctaEmailClick = () => sendEmailOTP(true);
    }
  }

  return (
    <Fragment>
      <div className={styles.input_parent_phone}>
        <div className={styles.top_heading}>
          <MUITextField
            className={styles.password}
            isRequired={true}
            type="text"
            isForm={true}
            label="Email"
            value={email}
            onChange={() => {}}
            propsError={""}
            maxLength={50}
            helperText={otpSent ? "OTP is sent to your email" : ""}
            ctaText={otpSent ? ctaEmailText : undefined}
            ctaClick={otpSent ? ctaEmailClick : undefined}
            isDisabled={true}
          />
        </div>
        {!otpSent && isCaptchaRequired && recaptchaV2Key && (
          <div className={styles.top_heading}>
            <ReCAPTCHA
              sitekey={recaptchaV2Key}
              enterprise={false}
              onChange={(token) => {
                setCaptchaV2Token(token || "");
                setIsCaptchaVerified(Boolean(token));
                setEmailOtpError("");
              }}
              onExpired={() => {
                setCaptchaV2Token("");
                setIsCaptchaVerified(false);
              }}
              onErrored={() => {
                setEmailOtpError("Verification failed to load. Please refresh the page and try again.");
              }}
            />
          </div>
        )}
        {!otpSent && !!emailOtpError && (
          <div className={styles.top_heading}>
            <div className={styles.error}><p>{emailOtpError}</p></div>
          </div>
        )}
        {otpSent ? (
          <>
            <div className={styles.top_heading}>
              <MUITextField
                className={styles.password}
                isRequired={true}
                type="text"
                isForm={true}
                label="Enter OTP"
                value={emailOtp !==""?emailOtp.replace(/[^0-9]/gi, ""):""}
                onChange={(e) => {
                  if (e.target.value.length < 5) {
                    setEmailOtp(e.target.value);
                  }
                }}
                propsError={emailOtpError}
                maxLength={50}
                onKeyPress={(e) => {
                  e.key === "Enter" && verifyEmailOTP();
                }}
              />
            </div>
            <div className={styles.top_heading}>
              <Button 
                className={styles.email_otp_verify_btn}
                text="Verify OTP"
                loading={btnLoader}
                disabled={emailOtp.length !== 4}
                onClick={() => {
                  if (emailOtp) {
                    verifyEmailOTP();
                  }
                }}
              />
            </div>
          </>
        ) : (
          <div className={styles.top_heading}>
            <Button 
              className={styles.email_otp_verify_btn}
              text="Send OTP"
              loading={btnLoader}
              disabled={isCaptchaRequired && !isCaptchaVerified}
              onClick={() => sendEmailOTP(false)}
            />
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default EmailVerification;
